<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-home`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.33496 1.38135C7.77255 1.28191 8.22745 1.28191 8.66504 1.38135C9.15985 1.49383 9.62115 1.78312 10.5439 2.35986L12.5439 3.60986C13.3673 4.12449 13.7794 4.38146 14.0781 4.72998C14.3424 5.03836 14.5416 5.39715 14.6631 5.78467C14.8003 6.22269 14.7998 6.70906 14.7998 7.68018V9.56982C14.7998 11.2495 14.7995 12.0893 14.4727 12.731C14.1851 13.2954 13.7265 13.7549 13.1621 14.0425C12.5204 14.3695 11.6802 14.3696 10 14.3696H6C4.31984 14.3696 3.47963 14.3695 2.83789 14.0425C2.27345 13.7549 1.81495 13.2954 1.52734 12.731C1.2005 12.0893 1.2002 11.2495 1.2002 9.56982V7.68018C1.2002 6.70907 1.19966 6.22269 1.33691 5.78467C1.45839 5.39715 1.65761 5.03836 1.92188 4.72998C2.22055 4.38146 2.63266 4.12449 3.45605 3.60986L5.45605 2.35986C6.37885 1.78312 6.84015 1.49383 7.33496 1.38135ZM8.00391 8.20752C7.45187 8.2077 7.00405 8.65547 7.00391 9.20752V11.2378C7.00391 11.79 7.45178 12.2376 8.00391 12.2378C8.55619 12.2378 9.00391 11.7901 9.00391 11.2378V9.20752C9.00377 8.65535 8.5561 8.20752 8.00391 8.20752Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillHome',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
